import React, {useEffect, useRef, useState} from 'react';
import {addLocale} from "primereact/api";
import {locales} from "../../../shared/types/constantes";
import {UsePermissions} from "../../../hooks/usePermissions";
import {UseLoader} from "../../../hooks/useLoader";
import {getAsociados} from "../../../api/liquidacionDeduccion.service";
import {convertirModena} from "../../../shared/utils/utils";
import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {editarFondo, getInfoFondos, getInfoFondosAjuste} from "../../../api/pagoFondos.service";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import NumberFormat from "react-number-format";

const AjusteFondoTable = () => {
    addLocale('es', locales);
    const [permisos] = UsePermissions();
    const [handleLoad] = UseLoader();
    const toast = useRef(null);

    const [isDateShow, setIsDateShow] = useState(false);
    const [fondosList, setFondosList] = useState([]);
    const [fondosTotal, setFondosTotal] = useState(0);

    const [fondos, setFondos] = useState([]);

    const [FilteredFondo, setFilteredFondo] = useState(null);
    const [clientes, setClientes] = useState([]);


    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: ""
    });
    const [FilteredCliente, setFilteredCliente] = useState(null);

    const initParams = {
        asociado_id: '',
    };


    const [field, setField] = useState(initParams);

    const paramsSave = {
        asociado_id: '',
    };

    const [fieldSave, setFieldSave] = useState(paramsSave);

    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {

        };
    }, []);


    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const valorBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor);
    }

    const setFieltsAsoc = (id) => {
        setField({...field, asociado_id: id})
        setFieldSave({...fieldSave, asociado_id: id})
    }

    const buscarFondos = async () => {
        try {
            handleLoad(true);
            const response = await getInfoFondosAjuste(field);
            handleLoad(false);
            if (response.estado !== 200) {
                setFondosList([]);
                setFondosTotal(0)
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }

            setFondosList(response.data.fondos);
            setFondosTotal(response.data.total)

        } catch (e) {
            handleLoad(false);
        }
    }

    const textEditor = (options) => {
        return <NumberFormat
            id="valor"
            thousandsGroupStyle="thousand"
            value={options.value}
            prefix="$"
            displayType="input"
            type="text"
            decimalSeparator="."
            className="form-input-small "
            thousandSeparator={true}
            allowNegative={true}
            onValueChange={(e) => options.editorCallback(e.value)}
        />
    }

    const onCellEditComplete = (e) => {
        console.log(e)
        let {rowData, newValue, field, newRowData, originalEvent: event} = e;
        if (newValue.trim().length > 0) {
            rowData[field] = newValue;
            guardarNuevoFondo(newRowData)
        } else {
            event.preventDefault();
        }
    }

    const guardarNuevoFondo = (fondo) => {
        const {liquidacionprestacion_id, valor} = fondo;
        editarNuevoFondo(liquidacionprestacion_id, valor)
    }

    const editarNuevoFondo = (id, valor) => {
        editarFondo({
            liquidacionprestacion_id: id,
            valor: valor
        }).then(data => {
            if (data.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                return;
            }

            toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
        })
    }


    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <div className=" flex flex-wrap items-center  p-4 primary-color">
                {permisos.consultar === 1 && clientes.length > 0 ?
                    <div className=" mt-2 relative lg:w-4/12 px-4">
                        <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                      style={{"width": "100%"}}
                                      completeMethod={searchCliente}
                                      placeholder="Buscador afiliados"
                                      size="30"
                                      field="nombre" dropdown itemTemplate={itemTemplate}
                                      onSelect={(e) => setFieltsAsoc(e.value.id)}
                                      onChange={(e) => setSelectedcliente(e.value)}/>
                    </div>
                    : ""}

                <ContainerGroupForm width="lg:w-3/12">
                    <div className="mt-6 relative w-full px-4">
                        <button
                            className="warning-color-btn btn w-full"
                            onClick={buscarFondos}
                        >
                            Buscar
                        </button>
                    </div>

                </ContainerGroupForm>
            </div>

            <ContainerTable>
                <DataTable
                    showGridlines
                    resizableColumns
                    columnResizeMode="expand"
                    size="small"
                    editMode="cell"
                    scrollable
                    scrollHeight="400px"
                    value={fondosList}
                    responsiveLayout="scroll">
                    <Column field="fondo" header="Fondo" sortable filter
                            showFilterMatchModes={false}
                    ></Column>


                    <Column field="valor"
                            header="Valor"
                            sortable filter
                            onCellEditComplete={onCellEditComplete}
                            editor={(options) => textEditor(options)}
                            body={valorBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>
                    <Column field="fecha" sortable filter header="Fecha" showFilterMatchModes={false}
                    ></Column>
                    <Column field="nombre" sortable filter header="Cliente" showFilterMatchModes={false}
                    ></Column>

                </DataTable>
            </ContainerTable>
        </>
    );
};

export default AjusteFondoTable;

